import React from 'react'
import Input from './Input'
import PropTypes from 'prop-types'

export default function Password (props) {
  return (
    <Input autoComplete={props.new === true ? 'new-password' : props.autoComplete} {...props} type='password' />
  )
}

Password.defaultProps = {
  ...Input.defaultProps,
  new: false
}

Password.propTypes = {
  ...Input.propTypes,
  new: PropTypes.bool
}
